import PropTypes from 'prop-types';
import React from 'react';

import ContainerLink from 'samples/containers/ContainerLink';
import AncestralStorables from 'samples/storables/AncestralStorables';

interface OptionalContainerLinkWithLocationProps {
  containerId?: string | null;
  truncateLocation?: boolean;
}

const OptionalContainerLinkWithLocation: React.FunctionComponent<OptionalContainerLinkWithLocationProps> = ({
  containerId,
  truncateLocation,
}: OptionalContainerLinkWithLocationProps) => {
  if (containerId) {
    return (
      <div>
        <ContainerLink containerId={containerId} />
        <br />
        <AncestralStorables
          className="richObjectTable-detailText"
          noLocationText="No location"
          storableId={containerId}
          showGridCell={true}
          truncate={truncateLocation}
        />
      </div>
    );
  } else {
    return <span className="u-italic">Not selected</span>;
  }
};
OptionalContainerLinkWithLocation.propTypes = {
  containerId: PropTypes.string,
  truncateLocation: PropTypes.bool,
};

export default OptionalContainerLinkWithLocation;
